import jwt from 'jsonwebtoken';
import { ARTISAN } from '@lba-dev/package.local-globals/permissions';

import { logout } from '../actions/auth';
import initCache from '../cache';
import ws from '../ws';
import api from '../api';
import { addUserSession } from './datadog';
import initEvents from './Events';

let token;
let timeout;

export const setupTokenManagement = (store) => {
  const onTokenChange = () => {
    const state = store.getState();
    if (state.auth.token !== token) {
      token = state.auth.token;
      api.header('Authorization', `Bearer ${token}`);

      if (token === undefined) {
        ws.logout();
        return;
      }

      const payload = jwt.decode(token);
      if (payload && payload.exp && payload.exp > Date.now() / 1000) {
        clearTimeout(timeout);
        ws.login({ token, payload });
        window.localStorage.setItem('token', token);

        timeout = setTimeout(
          () => store.dispatch(logout(ws)),
          (payload.exp * 1000) - Date.now()
        );

        if (payload.auth !== ARTISAN) {
          initCache(store, payload._id, ws, window.name === 'chat');
          addUserSession(payload);
          initEvents(payload);
        }
      } else {
        store.dispatch(logout(ws, payload));
      }
    }
  };

  store.subscribe(onTokenChange);
  onTokenChange();
};
